import moment from "moment";
const year = moment().format("YYYY");
export const authData = [
  {
    title: "Hotel Information <br/> 酒店信息",
    value: "/table/cover",
    key: "/table/cover",
    children: [
      {
        title: "查看",
        key: "read_cover",
      },
      {
        title: "编辑",
        key: "edit_cover",
      },
    ],
  },
  {
    title: "Hotel Data Index <br/> 酒店数据分析",
    value: "/table/hoteldataindex",
    key: "/table/hoteldataindex",
    children: [
      {
        title: "Performance Analysis <br/> 酒店经营情况分析",
        value: "/table/performanceAnalysisAll",
        key: "/table/performanceAnalysisAll",
        children: [
          {
            title: "1.1 Performance Analysis 酒店经营情况分析",
            value: "/table/performanceAnalysis",
            key: "/table/performanceAnalysis",
            children: [
              {
                title: "查看",
                key: "read_performanceAnalysis",
              },
              {
                title: "编辑",
                key: "edit_performanceAnalysis",
              },
            ],
          },
          {
            title: "1.2 Data Visualization 数据可视化",
            value: "/table/analysisChart",
            key: "/table/analysisChart",
            children: [
              {
                title: "查看",
                key: "read_analysisChart",
              },
              {
                title: "编辑",
                key: "edit_analysisChart",
              },
            ],
          },
          {
            title: "1.3 Breakdown Statistics Data 统计数据归集依据",
            value: "/table/performancedescription",
            key: "/table/performancedescription",
            children: [
              {
                title: "查看",
                key: "read_performancedescription",
              },
              {
                title: "编辑",
                key: "edit_performancedescription",
              },
            ],
          },
          {
            title: "1.4 Performance Review 2019上半年酒店经营情况回顾",
            value: "/table/performanceReview",
            key: "/table/performanceReview",
            children: [
              {
                title: "查看",
                key: "read_performanceReview",
              },
              {
                title: "编辑",
                key: "edit_performanceReview",
              },
            ],
          },
        ],
      },
      {
        title: "Efficiency Per Square Meter Analysis<br/> 酒店坪效经营情况分析",
        value: "/table/efficiencyAll",
        key: "/table/efficiencyAll",
        children: [
          {
            title:
              "1.1 Efficiency Per Square Meter Analysis 酒店坪效经营情况分析",
            value: "/table/efficiency",
            key: "/table/efficiency",
            children: [
              {
                title: "查看",
                key: "read_efficiency",
              },
              {
                title: "编辑",
                key: "edit_efficiency",
              },
            ],
          },
          {
            title: "1.2 Meeting Room Occ 会议室需求统计",
            value: "/table/effect1_2",
            key: "/table/effect1_2",
            children: [
              {
                title: "查看",
                key: "read_effect1_2",
              },
              {
                title: "编辑",
                key: "edit_effect1_2",
              },
            ],
          },
          {
            title: "1.3 Breakdown Statistics Data 统计数据归集依据",
            value: "/table/effictdescription",
            key: "/table/effictdescription",
            children: [
              {
                title: "查看",
                key: "read_effictdescription",
              },
              {
                title: "编辑",
                key: "edit_effictdescription",
              },
            ],
          },
        ],
      },
      {
        title: "Hotel OTA Channel Performance <br/>酒店OTA渠道表现",
        value: "/table/ota",
        key: "/table/ota",
        children: [
          {
            title:
              "1.1 Fliggy Store Rooms Nights Ranking - Current Month 集团飞猪旗舰店当月客房间夜数销售排名",
            value: "/table/otashow",
            key: "/table/otashow",
            children: [
              {
                title: "查看",
                key: "read_otashow",
              },
              {
                title: "编辑",
                key: "edit_otashow",
              },
            ],
          },
          {
            title:
              "1.2 Ctrip Rooms Revenue & Nights Ranking 携程平台集团酒店本年客房收益与间夜数销售排名（不含供应商数据）",
            value: "/table/otashowctrip",
            key: "/table/otashowctrip",
            children: [
              {
                title: "查看",
                key: "read_otashowctrip",
              },
              {
                title: "编辑",
                key: "edit_otashowctrip",
              },
            ],
          },
          {
            title:
              "1.3 Meituan Rooms Revenue & Nights Ranking 美团平台集团酒店本年客房收益与间夜数销售排名（不含供应商数据）",
            value: "/table/otashowmeituan",
            key: "/table/otashowmeituan",
            children: [
              {
                title: "查看",
                key: "read_otashowmeituan",
              },
              {
                title: "编辑",
                key: "edit_otashowmeituan",
              },
            ],
          },
          {
            title:
              "1.4 GCH Mini Program Rooms Revenue & Nights Ranking - Current Month 集团官网小程序当月客房收益与间夜数销售排名",
            value: "/table/otaappletrn",
            key: "/table/otaappletrn",
            children: [
              {
                title: "查看",
                key: "read_otaappletrn",
              },
              {
                title: "编辑",
                key: "edit_otaappletrn",
              },
            ],
          },
          {
            title:
              "1.5 GCH Mini Program Page View Ranking - Current Month 集团小程序当月访问量排名",
            value: "/table/otaapplet",
            key: "/table/otaapplet",
            children: [
              {
                title: "查看",
                key: "read_otaapplet",
              },
              {
                title: "编辑",
                key: "edit_otaapplet",
              },
            ],
          },
        ],
      },
      {
        title: "Price Repairing <br/> 官网比价",
        value: "/table/pricerepairing",
        key: "/table/pricerepairing",
        children: [
          {
            title: "1.1 Price Repairing 官网比价",
            value: "/table/price1_1",
            key: "/table/price1_1",
            children: [
              {
                title: "查看",
                key: "read_price1_1",
              },
              {
                title: "编辑",
                key: "edit_price1_1",
              },
            ],
          },
          {
            title: "1.2 Price Repairing Visual Diagram 官网比价可视化",
            value: "/table/price1_2",
            key: "/table/price1_2",
            children: [
              {
                title: "查看",
                key: "read_price1_2",
              },
              {
                title: "编辑",
                key: "edit_price1_2",
              },
            ],
          },
          {
            title: "1.3  Price Repairing File Upload 官网比价文件上传",
            value: "/table/price1_3",
            key: "/table/price1_3",
            children: [
              {
                title: "查看",
                key: "read_price1_3",
              },
              {
                title: "编辑",
                key: "edit_otashowmeituan",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Customer Satisfaction<br/> 客人满意度",
    value: "/table/guestratingAll",
    key: "/table/guestratingAll",
    children: [
      {
        title: "WynReview - Medallia 集团渠道",
        value: "/table/guestrating",
        key: "/table/guestrating",
        children: [
          {
            title: "查看",
            key: "read_guestrating",
          },
          {
            title: "编辑",
            key: "edit_guestrating",
          },
        ],
      },
      {
        title: "Online Travel Agency 网络平台",
        value: "/table/groupOfChannels",
        key: "/table/groupOfChannels",
        children: [
          {
            title: "查看",
            key: "read_groupOfChannels",
          },
          {
            title: "编辑",
            key: "edit_groupOfChannels",
          },
        ],
      },
    ],
  },
  {
    title: "Hotel Emergency Report 酒店紧急事件报告",
    value: "/table/urgent",
    key: "/table/urgent",
    children: [
      {
        title: "查看",
        key: "read_urgent",
      },
      {
        title: "编辑",
        key: "edit_urgent",
      },
    ],
  },
  {
    title: "Consulting Reports 第三方行业资讯报告摘要",
    value: "/table/consulting",
    key: "/table/consulting",
    children: [
      {
        title: "查看",
        key: "read_consulting",
      },
      {
        title: "编辑",
        key: "edit_consulting",
      },
    ],
  },
  {
    title: "Meeting Flash Report <br/>会议即时报表",
    value: "/table/meetingflash",
    key: "/table/meetingflash",
    children: [
      {
        title: "查看",
        key: "read_meetingflash",
      },
      {
        title: "编辑",
        key: "edit_meetingflash",
      },
    ],
  },
  {
    title: "KPI Follow参数",
    value: "/table/kpifollow",
    key: "/table/kpifollow",
    children: [
      {
        title: "查看",
        key: "read_kpifollow",
      },
      {
        title: "编辑",
        key: "edit_kpifollow",
      },
    ],
  },
  {
    title: "宴会设施统计",
    value: "/table/banquetFacilities",
    key: "/table/banquetFacilities",
    children: [
      {
        title: "查看",
        key: "read_banquetFacilities",
      },
      {
        title: "编辑",
        key: "edit_banquetFacilities",
      },
    ],
  },
  {
    title: "酒店系统统计",
    value: "/table/systemStatistical",
    key: "/table/systemStatistical",
    children: [
      {
        title: "查看",
        key: "read_systemStatistical",
      },
      {
        title: "编辑",
        key: "edit_systemStatistical",
      },
    ],
  },
  {
    title: `${year}年五一假期业绩情况`,
    value: "/table/mayday",
    key: "/table/mayday",
    children: [
      {
        title: "查看",
        key: "read_mayday",
      },
      {
        title: "编辑",
        key: "edit_mayday",
      },
    ],
  },
  {
    title: `${year}年国庆假期业绩情况`,
    value: "/table/nationalDay",
    key: "/table/nationalDay",
    children: [
      {
        title: "查看",
        key: "read_nationalDay",
      },
      {
        title: "编辑",
        key: "edit_nationalDay",
      },
    ],
  },
  {
    title: "财务月度分析报告",
    value: "/table/monthlyAnalysis",
    key: "/table/monthlyAnalysis",
    children: [
      {
        title: "查看",
        key: "read_monthlyAnalysis",
      },
      {
        title: "编辑",
        key: "edit_monthlyAnalysis",
      },
    ],
  },
  {
    title: "财务部人员评估",
    value: "/table/personnelAssessment",
    key: "/table/personnelAssessment",
    children: [
      {
        title: "查看",
        key: "read_personnelAssessment",
      },
      {
        title: "编辑",
        key: "edit_personnelAssessment",
      },
    ],
  },
  {
    title: "P&L Review Meeting Minutes<br/> 经营评估会议纪要",
    value: "/table/meetingMinutes",
    key: "/table/meetingMinutes",
    children: [
      {
        title: "查看",
        key: "read_meetingMinutes",
      },
      {
        title: "编辑",
        key: "edit_meetingMinutes",
      },
    ],
  },
  {
    title: "1.0 KPI - Key Performance Indicator<br/> 关键绩效指数",
    value: "/table/1",
    key: "/table/1",
    children: [
      {
        title: "查看",
        key: "read_1",
      },
      {
        title: "编辑",
        key: "edit_1",
      },
    ],
  },
  {
    title: "2.0 P&L Analysis<br/> 损益分析",
    value: "/table/2",
    key: "/table/2",
    children: [
      {
        title:
          "2.1 Current Year P&L Analysis (Whole Year Forecast = Actual + Forecast) 本年损益分析（全年预测 = 实际+预测）",
        value: "/table/2_1",
        key: "/table/2_1",
        children: [
          {
            title: "查看",
            key: "read_2_1",
          },
          {
            title: "编辑",
            key: "edit_2_1",
          },
        ],
      },
      {
        title:
          "2.2 Current Year P&L Analysis (Whole Year Budget) 本年损益分析 （全年预算）",
        value: "/table/2_2",
        key: "/table/2_2",
        children: [
          {
            title: "查看",
            key: "read_2_2",
          },
          {
            title: "编辑",
            key: "edit_2_2",
          },
        ],
      },
      ,
      {
        title:
          "2.3 Last Year P&L Analysis (Whole Year Actual) 前一年度损益分析 （全年实际）",
        value: "/table/2_3",
        key: "/table/2_3",
        children: [
          {
            title: "查看",
            key: "read_2_3",
          },
          {
            title: "编辑",
            key: "edit_2_3",
          },
        ],
      },
    ],
  },
  {
    title: "3.0 Guest Comments & Wyndham Rewards",
    value: "/table/3",
    key: "/table/3",
    children: [
      {
        title: "3.1 Online Guest Comments 顾客在线评论",
        value: "/table/2_7",
        key: "/table/2_7",
        children: [
          {
            title: "查看",
            key: "read_2_7",
          },
          {
            title: "编辑",
            key: "edit_2_7",
          },
        ],
      },
      {
        title: "3.2 Wyndham Rewards Enrollment 温德姆奖赏计划新会员加入",
        value: "/table/2_8",
        key: "/table/2_8",
        children: [
          {
            title: "查看",
            key: "read_2_8",
          },
          {
            title: "编辑",
            key: "edit_2_8",
          },
        ],
      },
    ],
  },
  {
    title: " 4.0 new Room Analysis",
    value: "/table/4_new",
    key: "/table/4_new",
    children: [
      {
        title: "4.2 新版市场细分表-月度",
        value: "/table/4_2_new",
        key: "/table/4_2_new",
        children: [
          {
            title: "4.2.1 Monthly Market Segment Report 月度市场细分表",
            value: "/table/4_2_1_new",
            key: "/table/4_2_1_new",
            children: [
              {
                title: "查看",
                key: "read_4_2_1_new",
              },
              {
                title: "编辑",
                key: "edit_4_2_1_new",
              },
            ],
          },
          {
            title: "4.2.2 未来3个月销售策略和行动计划",
            value: "/table/4_2_2_new",
            key: "/table/4_2_2_new",
            children: [
              {
                title: "查看",
                key: "read_4_2_2_new",
              },
              {
                title: "编辑",
                key: "edit_4_2_2_new",
              },
            ],
          },
        ],
      },
      {
        title: "4.3 新版市场细分表-年度",
        value: "/table/4_3_new",
        key: "/table/4_3_new",
        children: [
          {
            title: "4.3.1 Market Segment by Month <br/> 市场细分明细表月度分解",
            value: "/table/4_3_1_new",
            key: "/table/4_3_1_new",
            children: [
              {
                title: "查看",
                key: "read_4_3_1_new",
              },
              {
                title: "编辑",
                key: "edit_4_3_1_new",
              },
            ],
          },
          {
            title: "4.3.2 Key Market Segment By Month 市场细分月度汇总表",
            value: "/table/4_3_2_new",
            key: "/table/4_3_2_new",
            children: [
              {
                title: "查看",
                key: "read_4_3_2_new",
              },
              {
                title: "编辑",
                key: "edit_4_3_2_new",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "4.0 Rooms Analysis<br/> 客房分析",
    value: "/table/4",
    key: "/table/4",
    children: [
      {
        title: "销售部人员评估",
        value: "/table/salesPersonnelAssessment",
        key: "/table/salesPersonnelAssessment",
        children: [
          {
            title: "查看",
            key: "read_salesPersonnelAssessment",
          },
          {
            title: "编辑",
            key: "edit_salesPersonnelAssessment",
          },
        ],
      },
      {
        title: "4.0 集团区域报表",
        value: "/table/4_0_area",
        key: "/table/4_0_area",
        children: [
          {
            title: "区域报表",
            value: "/table/4_2_summary",
            key: "/table/4_2_summary",
            children: [
              {
                title: "查看",
                key: "read_4_2_summary",
              },
              {
                title: "编辑",
                key: "edit_4_2_summary",
              },
            ],
          },
          {
            title: "春节区域报表",
            value: "/table/chineseNewYear",
            key: "/table/chineseNewYear",
            children: [
              {
                title: "查看",
                key: "read_chineseNewYear",
              },
              {
                title: "编辑",
                key: "edit_chineseNewYear",
              },
            ],
          },
          {
            title: "五一区域报表",
            value: "/table/areaMayDay",
            key: "/table/areaMayDay",
            children: [
              {
                title: "查看",
                key: "read_areaMayDay",
              },
              {
                title: "编辑",
                key: "edit_areaMayDay",
              },
            ],
          },
          {
            title: "十一区域报表",
            value: "/table/eleven",
            key: "/table/eleven",
            children: [
              {
                title: "查看",
                key: "read_eleven",
              },
              {
                title: "编辑",
                key: "edit_eleven",
              },
            ],
          },
          {
            title: "年度区域报表",
            value: "/table/annualRegional",
            key: "/table/annualRegional",
            children: [
              {
                title: "查看",
                key: "read_annualRegional",
              },
              {
                title: "编辑",
                key: "edit_annualRegional",
              },
            ],
          },
          {
            title: "节日汇总表",
            value: "/table/4_2/holiday/summary",
            key: "/table/4_2/holiday/summary",
            children: [
              {
                title: "查看",
                key: "read_4_2_holidaySummary",
              },
              {
                title: "编辑",
                key: "edit_4_2_holidaySummary",
              },
            ],
          },
          {
            title: "区域满房报表",
            value: "/table/4_2/fullRoom",
            key: "/table/4_2/fullRoom",
            children: [
              {
                title: "查看",
                key: "read_4_2_fullRoom",
              },
              {
                title: "编辑",
                key: "edit_4_2_fullRoom",
              },
            ],
          },
        ],
      },
      {
        title: "4.1 Monthly Report月报",
        value: "/table/4_1",
        key: "/table/4_1",
        children: [
          {
            title: "查看",
            key: "read_4_1",
          },
          {
            title: "编辑",
            key: "edit_4_1",
          },
        ],
      },
      {
        title: "4.2 Daily Report 日报",
        value: "/table/4_2",
        key: "/table/4_2",
        children: [
          {
            title: "4.2.1 Daily Report 日报",
            value: "/table/4_2_1",
            key: "/table/4_2_1",
            children: [
              {
                title: "查看",
                key: "read_4_2_1",
              },
              {
                title: "编辑",
                key: "edit_4_2_1",
              },
            ],
          },
          {
            title: "4.2.2 Daily Report by Segmentation",
            value: "/table/4_2_2",
            key: "/table/4_2_2",
            children: [
              {
                title: "查看",
                key: "read_4_2_2",
              },
              {
                title: "编辑",
                key: "edit_4_2_2",
              },
            ],
          },
          {
            title: "4.2.3 Early Bird Report",
            value: "/table/4_2_3",
            key: "/table/4_2_3",
            children: [
              {
                title: "查看",
                key: "read_4_2_3",
              },
              {
                title: "编辑",
                key: "edit_4_2_3",
              },
            ],
          },
          {
            title: "4.2.4 Monthly Biz On-book Outlook",
            value: "/table/4_2_4",
            key: "/table/4_2_4",
            children: [
              {
                title: "查看",
                key: "read_4_2_4",
              },
              {
                title: "编辑",
                key: "edit_4_2_4",
              },
            ],
          },
          {
            title: "4.2.5 Daily Pick up Trend",
            value: "/table/4_2_5",
            key: "/table/4_2_5",
            children: [
              {
                title: "查看",
                key: "read_4_2_5",
              },
              {
                title: "编辑",
                key: "edit_4_2_5",
              },
            ],
          },
          {
            title: "4.2.6 Daily Pick up by Segmentation",
            value: "/table/4_2_6",
            key: "/table/4_2_6",
            children: [
              {
                title: "查看",
                key: "read_4_2_6",
              },
              {
                title: "编辑",
                key: "edit_4_2_6",
              },
            ],
          },
          {
            title: "4.2.7 Daily On-book by Status",
            value: "/table/4_2_7",
            key: "/table/4_2_7",
            children: [
              {
                title: "查看",
                key: "read_4_2_7",
              },
              {
                title: "编辑",
                key: "edit_4_2_7",
              },
            ],
          },
        ],
      },
      {
        title: "4.3 Top Account Analysis 关键客户分析",
        value: "/table/4_3",
        key: "/table/4_3",
        children: [
          {
            title: "查看",
            key: "read_4_3",
          },
          {
            title: "编辑",
            key: "edit_4_3",
          },
        ],
      },
      {
        title: "4.4 Geographic City(Domestic)/Country(oversea) Top 10",
        value: "/table/4_4",
        key: "/table/4_4",
        children: [
          {
            title: "查看",
            key: "read_4_4",
          },
          {
            title: "编辑",
            key: "edit_4_4",
          },
        ],
      },
      {
        title: "4.5 Rooms Revenue Up-selling Program 客房收入增销计划",
        value: "/table/4_5",
        key: "/table/4_5",
        children: [
          {
            title: "查看",
            key: "read_4_5",
          },
          {
            title: "编辑",
            key: "edit_4_5",
          },
        ],
      },
      {
        title: "4.6 Rooms KPI Analysis 客房关键绩效指数分析",
        value: "/table/3_1",
        key: "/table/3_1",
        children: [
          {
            title: "查看",
            key: "read_3_1",
          },
          {
            title: "编辑",
            key: "edit_3_1",
          },
        ],
      },
    ],
  },
  {
    title: "5.0 F&B Analysis<br/> 餐饮分析",
    value: "/table/5",
    key: "/table/5",
    children: [
      {
        title: "5.0 F&B Summary 餐饮关键绩效指数",
        value: "/table/5_0",
        key: "/table/5_0",
        children: [
          {
            title: "查看",
            key: "read_5_0",
          },
          {
            title: "编辑",
            key: "edit_5_0",
          },
        ],
      },
      {
        title: "5.1 F&B Revenue Analysis By Outlets 餐饮收入分析-按餐厅",
        value: "/table/5_1",
        key: "/table/5_1",
        children: [
          {
            title: "查看",
            key: "read_5_1",
          },
          {
            title: "编辑",
            key: "edit_5_1",
          },
        ],
      },
      {
        title: "5.2 Three Months Rolling Forecast 后三个月滚动预测",
        value: "/table/5_2",
        key: "/table/5_2",
        children: [
          {
            title: "查看",
            key: "read_5_2",
          },
          {
            title: "编辑",
            key: "edit_5_2",
          },
        ],
      },
      {
        title:
          "5.3~5.4 F&B 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划/F&B Advertising and Marketing Plan For Next 3 Months 后三个月针对餐饮的广告投放及营销计划",
        value: "/table/5_3",
        key: "/table/5_3",
        children: [
          {
            title: "查看",
            key: "read_5_3",
          },
          {
            title: "编辑",
            key: "edit_5_3",
          },
        ],
      },
      {
        title: "5.5 Breakfast & Club Lounge Revenue Allocation 早餐收入分配",
        value: "/table/5_5",
        key: "/table/5_5",
        children: [
          {
            title: "查看",
            key: "read_5_5",
          },
          {
            title: "编辑",
            key: "edit_5_5",
          },
        ],
      },
      {
        title:
          "5.6 F&B Unit Account & Individual Analysis 餐饮单位账号消费及个人账号消费分析",
        value: "/table/5_6",
        key: "/table/5_6",
        children: [
          {
            title: "查看",
            key: "read_5_6",
          },
          {
            title: "编辑",
            key: "edit_5_6",
          },
        ],
      },
      {
        title: " 5.7 F&B Outlets KPI Analysis 餐饮部餐厅关键绩效指数分析",
        value: "/table/3_2",
        key: "/table/3_2",
        children: [
          {
            title: "查看",
            key: "read_3_2",
          },
          {
            title: "编辑",
            key: "edit_3_2",
          },
        ],
      },
      {
        title:
          " 5.8 Chinese Restaurant Top 10 Favorite & Unpopular Dish Sales Summary 中餐厅菜品销售总结盘点",
        value: "/table/5_8",
        key: "/table/5_8",
        children: [
          {
            title: "查看",
            key: "read_5_8",
          },
          {
            title: "编辑",
            key: "edit_5_8",
          },
        ],
      },
      {
        title:
          "5.9 美团点评套餐销量统计 Meituan Dianping Package Sales Summary",
        value: "/table/5_9",
        key: "/table/5_9",
        children: [
          {
            title: "查看",
            key: "read_5_9",
          },
          {
            title: "编辑",
            key: "edit_5_9",
          },
        ],
      },
      {
        title: "5.10 单店分析",
        value: "/table/5_10",
        key: "/table/5_10",
        children: [
          {
            title: "查看",
            key: "read_5_10",
          },
          {
            title: "编辑",
            key: "edit_5_10",
          },
        ],
      },
    ],
  },
  {
    title: "6.0 Catering & Events (C&E) Analysis <br/>宴会活动分析",
    value: "/table/6",
    key: "/table/6",
    children: [
      {
        title:
          "6.1 Catering & Events (C&E) Analysis By Market Segment 宴会活动分析 - 按市场细分",
        value: "/table/6_1",
        key: "/table/6_1",
        children: [
          {
            title: "查看",
            key: "read_6_1",
          },
          {
            title: "编辑",
            key: "edit_6_1",
          },
        ],
      },
      {
        title:
          "6.2 F&B Catering/Banquet KPI Analysis 餐饮部宴会活动关键绩效指数分析",
        value: "/table/6_2",
        key: "/table/6_2",
        children: [
          {
            title: "查看",
            key: "read_6_2",
          },
          {
            title: "编辑",
            key: "edit_6_2",
          },
        ],
      },
      {
        title:
          "6.3 C&E 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划/C&E Advertising and Marketing Plan For Next 3 Months 后三个月正对宴会活动的广告投放及营销计划",
        value: "/table/6_3",
        key: "/table/6_3",
        children: [
          {
            title: "查看",
            key: "read_6_3",
          },
          {
            title: "编辑",
            key: "edit_6_3",
          },
        ],
      },
    ],
  },
  {
    title: "7.0 Human Resources Analysis <br/>人力资源分析",
    value: "/table/7",
    key: "/table/7",
    children: [
      {
        title: "7.1 Total Payroll Cost Analysis 薪酬总成本分析",
        value: "/table/7_1",
        key: "/table/7_1",
        children: [
          {
            title: "查看",
            key: "read_7_1",
          },
          {
            title: "编辑",
            key: "edit_7_1",
          },
        ],
      },
      {
        title: "7.2 Associate Movement 人员流动",
        value: "/table/7_2",
        key: "/table/7_2",
        children: [
          {
            title: "查看",
            key: "read_7_2",
          },
          {
            title: "编辑",
            key: "edit_7_2",
          },
        ],
      },
      {
        title:
          "7.3 Recruitment Plan (B2 and above, Vacant Positions) & Succession Plan 空缺职位招聘(B2级以上）及接班人计划",
        value: "/table/7_3",
        key: "/table/7_3",
        children: [
          {
            title: "查看",
            key: "read_7_3",
          },
          {
            title: "编辑",
            key: "edit_7_3",
          },
        ],
      },
      {
        title: "7.4 Training Statistics By Department 按部门培训记录统计",
        value: "/table/7_4",
        key: "/table/7_4",
        children: [
          {
            title: "查看",
            key: "read_7_4",
          },
          {
            title: "编辑",
            key: "edit_7_4",
          },
        ],
      },
      {
        title: "7.5 Annual Leave and Overtime 年假及加班",
        value: "/table/7_5",
        key: "/table/7_5",
        children: [
          {
            title: "查看",
            key: "read_7_5",
          },
          {
            title: "编辑",
            key: "edit_7_5",
          },
        ],
      },
      {
        title: "7.6 Training Plan For Next 1 Month 后一个月的培训计划",
        value: "/table/7_6",
        key: "/table/7_6",
        children: [
          {
            title: "查看",
            key: "read_7_6",
          },
          {
            title: "编辑",
            key: "edit_7_6",
          },
        ],
      },
      {
        title: `7.7 Data Visualization 人效数据可视化`,
        value: "/table/7_7",
        key: "/table/7_7",
        children: [
          {
            title: "查看",
            key: "read_7_7",
          },
          {
            title: "编辑",
            key: "edit_7_7",
          },
        ],
      },
      {
        title: `7.8 Labor Cost Productivity Analysis 人力成本生产率分析表`,
        value: "/table/7_8",
        key: "/table/7_8",
        children: [
          {
            title: "查看",
            key: "read_7_8",
          },
          {
            title: "编辑",
            key: "edit_7_8",
          },
        ],
      },
    ],
  },
  {
    title: "8.0 Utility Cost Trend Analysis <br/>能源成本趋势分析",
    value: "/table/8",
    key: "/table/8",
    children: [
      {
        title:
          "8.1~8.2 Utility Item 能源项目/Utility Conservation Measures 能源控制措施",
        value: "/table/8_1",
        key: "/table/8_1",
        children: [
          {
            title: "查看",
            key: "read_8_1",
          },
          {
            title: "编辑",
            key: "edit_8_1",
          },
        ],
      },
    ],
  },
  {
    title: "9.0 Financial Analysis<br/> 财务分析",
    value: "/table/9",
    key: "/table/9",
    children: [
      {
        title: "9.1 Balance Sheet 资产负债表",
        value: "/table/9_1",
        key: "/table/9_1",
        children: [
          {
            title: "查看",
            key: "read_9_1",
          },
          {
            title: "编辑",
            key: "edit_9_1",
          },
        ],
      },
      {
        title: "9.2 Accounts Receivable 应收账款",
        value: "/table/9_2",
        key: "/table/9_2",
        children: [
          {
            title: "查看",
            key: "read_9_2",
          },
          {
            title: "编辑",
            key: "edit_9_2",
          },
        ],
      },
      {
        title: "9.3 Accounts Payable 应付账款",
        value: "/table/9_3",
        key: "/table/9_3",
        children: [
          {
            title: "查看",
            key: "read_9_3",
          },
          {
            title: "编辑",
            key: "edit_9_3",
          },
        ],
      },
      {
        title:
          "9.4 Operating Equipment Stock taken Summary 营运工具盘点汇总 (at least Quarterly)",
        value: "/table/9_4",
        key: "/table/9_4",
        children: [
          {
            title: "查看",
            key: "read_9_4",
          },
          {
            title: "编辑",
            key: "edit_9_4",
          },
        ],
      },
      {
        title:
          "9.5 FFE Site Inspection Summary 固定资产盘点汇总 (at least half-yearly)",
        value: "/table/9_5",
        key: "/table/9_5",
        children: [
          {
            title: "查看",
            key: "read_9_5",
          },
          {
            title: "编辑",
            key: "edit_9_5",
          },
        ],
      },
      {
        title:
          "9.6 Capital Expenditure (CAPEX) and FF&E Reserve 固定资产及FF&E计提",
        value: "/table/9_6",
        key: "/table/9_6",
        children: [
          {
            title: "查看",
            key: "read_9_6",
          },
          {
            title: "编辑",
            key: "edit_9_6",
          },
        ],
      },
      {
        title: "9.7 Department Expenses 部门费用",
        value: "/table/9_7",
        key: "/table/9_7",
        children: [
          {
            title: "查看",
            key: "read_9_7",
          },
          {
            title: "编辑",
            key: "edit_9_7",
          },
        ],
      },
      {
        title: "9.8 Food Purchase Top 15 List 食品采购前15位清单",
        value: "/table/9_8",
        key: "/table/9_8",
        children: [
          {
            title: "查看",
            key: "read_9_8",
          },
          {
            title: "编辑",
            key: "edit_9_8",
          },
        ],
      },
      {
        title: "9.9 Rebate Summary 收入抵减汇总",
        value: "/table/9_9",
        key: "/table/9_9",
        children: [
          {
            title: "查看",
            key: "read_9_9",
          },
          {
            title: "编辑",
            key: "edit_9_9",
          },
        ],
      },
      {
        title: "9.10 Finance Internal Control Checklist 财务内部控制清单",
        value: "/table/9_10",
        key: "/table/9_10",
        children: [
          {
            title: "查看",
            key: "read_9_10",
          },
          {
            title: "编辑",
            key: "edit_9_10",
          },
        ],
      },
    ],
  },
  {
    title:
      "10.0~11.0 CSR and Community Activities <br/>企业社会责任及社区活动/Other Issues 其他事宜",
    value: "/table/10",
    key: "/table/10",
    children: [
      {
        title: "查看",
        key: "read_10",
      },
      {
        title: "编辑",
        key: "edit_10",
      },
    ],
  },
  {
    title: "12.0 Club GCH 豪廷會",
    value: "/table/12",
    key: "/table/12",
    children: [
      {
        title: "查看",
        key: "read_12",
      },
      {
        title: "编辑",
        key: "edit_12",
      },
    ],
  },
  {
    title: "Daily Revenue Report 每日经营报表",
    value: "/table/daily",
    key: "/table/daily",
    children: [
      {
        title: "查看",
        key: "read_daily",
      },
      {
        title: "编辑",
        key: "edit_daily",
      },
    ],
  },
  {
    title: "PDF Version PDF 报表",
    value: "/table/pdf",
    key: "/table/pdf",
    children: [
      {
        title: "查看",
        key: "read_pdf",
      },
      {
        title: "编辑",
        key: "edit_pdf",
      },
    ],
  },
  {
    title: "Business Plan 年度经营预算",
    value: "/bp",
    key: "/bp",
    children: [
      {
        title: "查看",
        key: "read_bp",
      },
      {
        title: "编辑",
        key: "edit_bp",
      },
    ],
  },
  {
    title: "Human Resources 人力资源报告",
    value: "/hr",
    key: "/hr",
    children: [
      {
        title: "查看",
        key: "read_hr",
      },
      {
        title: "编辑",
        key: "edit_hr",
      },
    ],
  },
  {
    title: "Headquarters Menu Summary<br/> 总部菜单汇总",
    value: "/table/headquarters",
    key: "/table/headquarters",
    children: [
      {
        title: "BI Structure - Hotel <br/>酒店数据平台",
        value: "/table/general",
        key: "/table/general",
        children: [
          {
            title: "查看",
            key: "read_general",
          },
          {
            title: "编辑",
            key: "edit_general",
          },
        ],
      },
      {
        title: "BI Structure - Corporate Office <br/>总部数据平台",
        value: "/table/bi_headquarters",
        key: "/table/bi_headquarters",
        children: [
          {
            title: "查看",
            key: "read_bi_headquarters",
          },
          {
            title: "编辑",
            key: "edit_bi_headquarters",
          },
        ],
      },
      {
        title: "BI Structure - DOO <br/>总部数据平台 - DOO",
        value: "/table/doobi",
        key: "/table/doobi",
        children: [
          {
            title: "查看",
            key: "read_doobi",
          },
          {
            title: "编辑",
            key: "edit_doobi",
          },
        ],
      },
      {
        title: "月度回顾表 Monthly ES Review",
        value: "/table/monthlyreview",
        key: "/table/monthlyreview",
        children: [
          {
            title: "查看",
            key: "read_monthlyreview",
          },
          {
            title: "编辑",
            key: "edit_monthlyreview",
          },
        ],
      },
      {
        title: "HQ Sales <br/> 总部销售部",
        value: "/table/Sales",
        key: "/table/Sales",
        children: [
          {
            title: "Budget Summary",
            value: "/table/BPBudgetSummary",
            key: "/table/BPBudgetSummary",
            children: [
              {
                title: "查看",
                key: "read_BPBudgetSummary",
              },
              {
                title: "编辑",
                key: "edit_BPBudgetSummary",
              },
            ],
          },
          {
            title: "BP8.2.1 Budget By Market Segment汇总表",
            value: "/table/BPBudgetSummary8_2_1",
            key: "/table/BPBudgetSummary8_2_1",
            children: [
              {
                title: "查看",
                key: "read_BPBudgetSummary8_2_1",
              },
              {
                title: "编辑",
                key: "edit_BPBudgetSummary8_2_1",
              },
            ],
          },
          {
            title: "Revenue monthly summary 单体酒店月度收益报表",
            value: "/table/headquartersmonth",
            key: "/table/headquartersmonth",
            children: [
              {
                title: "查看",
                key: "read_headquartersmonth",
              },
              {
                title: "编辑",
                key: "edit_headquartersmonth",
              },
            ],
          },
          {
            title: "Monthly completion trend 单体酒店月度完成趋势",
            value: "/table/headquartersyear",
            key: "/table/headquartersyear",
            children: [
              {
                title: "查看",
                key: "read_headquartersyear",
              },
              {
                title: "编辑",
                key: "edit_headquartersyear",
              },
            ],
          },
          {
            title: "Rooms KPI Analysis Summary 客房关键绩效指数分析汇总",
            value: "/table/roomsKPIAnalysisSummary",
            key: "/table/roomsKPIAnalysisSummary",
            children: [
              {
                title: "查看",
                key: "read_roomsKPIAnalysisSummary",
              },
              {
                title: "编辑",
                key: "edit_roomsKPIAnalysisSummary",
              },
            ],
          },
          {
            title: "Excel data import Excel 数据导入",
            value: "/table/guestReviewImport",
            key: "/table/guestReviewImport",
            children: [
              {
                title: "查看",
                key: "read_guestReviewImport",
              },
              {
                title: "编辑",
                key: "edit_guestReviewImport",
              },
            ],
          },
        ],
      },
      {
        title: "Daily Revenue Report <br/> 每日经营报表",
        value: "/table/dailyM",
        key: "/table/dailyM",
        children: [
          {
            title: "1.1 每日经营报表月度汇总",
            value: "/table/dailyMonth",
            key: "/table/dailyMonth",
            children: [
              {
                title: "查看",
                key: "read_dailyMonth",
              },
              {
                title: "编辑",
                key: "edit_dailyMonth",
              },
            ],
          },
          {
            title: "1.2 单酒店月度数据去年同比分析",
            value: "/table/dailyChart",
            key: "/table/dailyChart",
            children: [
              {
                title: "查看",
                key: "read_dailyChart",
              },
              {
                title: "编辑",
                key: "edit_dailyChart",
              },
            ],
          },
          {
            title: "1.3 酒店月度统计汇总",
            value: "/table/dailyMonthAllHotels",
            key: "/table/dailyMonthAllHotels",
            children: [
              {
                title: "查看",
                key: "read_dailyMonthAllHotels",
              },
              {
                title: "编辑",
                key: "edit_dailyMonthAllHotels",
              },
            ],
          },
          {
            title: "1.4 酒店月度餐饮统计汇总",
            value: "/table/dailyMonthAllHotels1_4",
            key: "/table/dailyMonthAllHotels1_4",
            children: [
              {
                title: "查看",
                key: "read_dailyMonthAllHotels1_4",
              },
              {
                title: "编辑",
                key: "edit_dailyMonthAllHotels1_4",
              },
            ],
          },
          {
            title: "1.5 每日经营报表报警记录",
            value: "/table/dailyMonthAllHotels1_5",
            key: "/table/dailyMonthAllHotels1_5",
            children: [
              {
                title: "查看",
                key: "read_dailyMonthAllHotels1_5",
              },
              {
                title: "编辑",
                key: "edit_dailyMonthAllHotels1_5",
              },
            ],
          },
          {
            title: "1.6 Daily Visual Diagram 日数据可视化图表",
            value: "/table/groupanalysisChart",
            key: "/table/groupanalysisChart",
            children: [
              {
                title: "查看",
                key: "read_groupanalysisChart",
              },
              {
                title: "编辑",
                key: "edit_groupanalysisChart",
              },
            ],
          },
        ],
      },
      {
        title: "情况分析利润调整",
        value: "/table/profit",
        key: "/table/profit",
        children: [
          {
            title: "查看",
            key: "read_profit",
          },
          {
            title: "编辑",
            key: "edit_profit",
          },
        ],
      },
      {
        title:
          "Fliggy Store Rooms Nights Ranking - Current Month<br/> 集团飞猪旗舰店当月客房间夜数销售排名",
        value: "/table/otafillin",
        key: "/table/otafillin",
        children: [
          {
            title: "查看",
            key: "read_otafillin",
          },
          {
            title: "编辑",
            key: "edit_otafillin",
          },
        ],
      },
      {
        title: "合同管理",
        value: "/table/contract_manage",
        key: "/table/contract_manage",
        children: [
          {
            title: "查看",
            key: "read_contract_manage",
          },
          {
            title: "编辑",
            key: "edit_contract_manage",
          },
        ],
      },
    ],
  },
  {
    title: "Simple Report<br/> 简易数据汇总表",
    value: "/table/charter",
    key: "/table/charter",
    children: [
      {
        title: "the first season<br/> 第一季度",
        value: "/table/charter/one",
        key: "/table/charter/one",
        children: [
          {
            title: "查看",
            key: "read_one",
          },
          {
            title: "编辑",
            key: "edit_one",
          },
        ],
      },
      {
        title: "the second season <br/>第二季度",
        value: "/table/charter/two",
        key: "/table/charter/two",
        children: [
          {
            title: "查看",
            key: "read_two",
          },
          {
            title: "编辑",
            key: "edit_two",
          },
        ],
      },
      {
        title: "the third season <br/>第三季度",
        value: "/table/charter/three",
        key: "/table/charter/three",
        children: [
          {
            title: "查看",
            key: "read_three",
          },
          {
            title: "编辑",
            key: "edit_three",
          },
        ],
      },
      {
        title: "the fourth season<br/> 第四季度",
        value: "/table/charter/four",
        key: "/table/charter/four",
        children: [
          {
            title: "查看",
            key: "read_four",
          },
          {
            title: "编辑",
            key: "edit_four",
          },
        ],
      },
      {
        title: "PL",
        value: "/table/charter/summary",
        key: "/table/charter/summary",
        children: [
          {
            title: "查看",
            key: "read_summary",
          },
          {
            title: "编辑",
            key: "edit_summary",
          },
        ],
      },
    ],
  },
];

export default authData;



// WEBPACK FOOTER //
// ./src/components/setting/data.js